import React from "react";
import {PatronThemeProvider, View} from "@unibuddy/patron";
import {TileMedia, MediaType, contentUITheme} from "@unibuddy/content-ui";

import {ContentCardBody} from "./ContentCardBody";
import {ContentCardHeader} from "./ContentCardHeader";
import {getMediaAndMediaType} from "./utils";
import {BlogPostField} from "../../../../../types/generated";

const customContentUITheme = {
    ...contentUITheme,
    TileBody: {
        default: {
            flex: null,
        },
    },
};

const Tile = ({height, children}) => {
    return (
        <View
            position="relative"
            borderRadius="xsmall"
            overflow="hidden"
            flexDirection="column"
            bgColor="white"
            flexShrink={0}
            borderWidth={1}
            borderColor="grey150"
            w="100%"
            h={height}
            maxH={height}
            // Added minH because Safari/iPhones break when using 100%
            // instead of a hardcoded value. We chose 340px because across
            // our current breakpoints (29/10/2024), this is the smallest
            // any card can ever be.
            minH="340px"
        >
            {children}
        </View>
    );
};

export function ContentCard({
    post,
    contentUrl,
    position,
    height = "412px",
}: {
    post: BlogPostField;
    contentUrl: string;
    position: number;
    height?: string;
}) {
    const {media, mediaType} = getMediaAndMediaType(post);

    if (!media || !mediaType) return null;

    return (
        <Tile height={height}>
            <TileMedia media={media} mediaType={mediaType} autoPlay={false}>
                <ContentCardHeader post={post} />
                {mediaType !== MediaType.IMAGE && (
                    <ContentCardBody
                        post={post}
                        contentUrl={contentUrl}
                        mediaType={mediaType}
                        position={position}
                    />
                )}
            </TileMedia>
            {mediaType === MediaType.IMAGE && (
                <PatronThemeProvider theme={customContentUITheme}>
                    <ContentCardBody
                        post={post}
                        contentUrl={contentUrl}
                        mediaType={mediaType}
                        position={position}
                    />
                </PatronThemeProvider>
            )}
        </Tile>
    );
}
